module.exports = __webpack_public_path__ + "static/img/4.7d861d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/zombs/4.png
// module id = YsAl
// module chunks = 35